module.exports = __webpack_public_path__ + "static/media/filetype-pdf.ed78c450.svg";